import {Duration} from '../Domain/Duration';
import {RangeOverview} from '../Strokes/calculateRangeOverview';
import {FullWorkoutPartResult} from './FullWorkout';
import {Speed} from '../Domain/Speed';
import {Split} from '../Business/calculateSplitTimes';

export interface RangeInput {
    start: Duration;
    end: Duration;
    // For intervals most values are already known and can be provided, to prevent
    // inconsistent data from being shown these values are used and enriched with
    // the calculated values
    predetermined: Partial<RangeOverview>;
}

export function fullWorkoutPartResultToRangeOverview(
    fullWorkoutPartResult: FullWorkoutPartResult,
): Partial<RangeOverview> {
    return {
        totalDuration: fullWorkoutPartResult.elapsed_time,
        totalDistance: fullWorkoutPartResult.traveled_distance,
        averagePower: fullWorkoutPartResult.average_power,
        averageStrokeRate: fullWorkoutPartResult.average_stroke_rate,
        averageSpeed: Speed.fromDurationPer500Meters(fullWorkoutPartResult.average_split),
        averageStrokeLength: fullWorkoutPartResult.average_stroke_length,
        averageEnergy: fullWorkoutPartResult.average_energy_per_stroke,
        averagePeakForce: fullWorkoutPartResult.average_peak_force,
        relativePeakForcePosition: fullWorkoutPartResult.average_relative_peak_force_position,
        averageDriveTime: fullWorkoutPartResult.average_drive_time,
        averageRecoverTime: fullWorkoutPartResult.average_recover_time,
    };
}

export function splitToRangeOverview(split: Split): Partial<RangeOverview> {
    return {
        totalDuration: split.duration,
        totalDistance: split.distance,
        averageSpeed: split.speed,
        averagePower: split.power,
        averageStrokeRate: split.strokeRate,
        heartRate: split.heartRate,
    };
}
